export default function CoinsRoundedIcon({ size = 26, color: _1, filled: _2, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="13" cy="13" r="13" fill="#272733" />
      <g transform="translate(1.5, -1.5)">
        <ellipse cx="11" cy="11.5" rx="4.5" ry="2" stroke="white" strokeWidth="1.4" fill="none" />
        <path d="M6.5 11.5v3c0 1.1 2 2 4.5 2s4.5-.9 4.5-2v-3" stroke="white" strokeWidth="1.4" fill="none" />
        <path
          d="M15.5 12.5c1.4.4 2.5 1 2.5 1.75 0 1.1-2 2-4.5 2"
          stroke="white"
          strokeWidth="1.4"
          fill="none"
          strokeLinecap="round"
        />
        <path d="M15.5 15.5v1.75c0 1.1-2 2-4.5 2" stroke="white" strokeWidth="1.4" fill="none" strokeLinecap="round" />
        <path d="M18 14.25v1.75c0 1.1-2 2-4.5 2" stroke="white" strokeWidth="1.4" fill="none" strokeLinecap="round" />
      </g>
    </svg>
  );
}
